module.exports = __webpack_public_path__ + "static/media/careers-peopple.ab6875a0.png";